import { Link } from "gatsby"
import { GoArrowUpRight } from "react-icons/go"

type ChipProps = {
  text: string
  variant?: "primary" | "secondary" | "tertiary"
  size?: "sm" | "md" | "lg"
  link?: string
  style?: "link" | "chip"
}

export const Chip = ({
  text,
  variant = "primary",
  size = "md",
  link = "",
}: ChipProps) => {
  const sizes = {
    sm: {
      wrapper: "pl-4 pr-10 py-1.5 text-sm",
      iconWrapper: "w-6 h-6",
      icon: 14,
    },
    md: {
      wrapper: "pl-5 pr-12 py-2 text-base",
      iconWrapper: "w-8 h-8",
      icon: 16,
    },
    lg: {
      wrapper: "pl-6 pr-14 py-2 text-lg",
      iconWrapper: "w-9 h-9",
      icon: 18,
    },
  }

  const variants = {
    primary: {
      wrapper: "bg-[#FFE9E680] border border-[#E9CDC9] text-black",
      icon: "bg-secondary-dark text-white",
    },
    secondary: {
      wrapper: "bg-secondary-dark text-white",
      icon: "bg-white text-secondary-dark",
    },
    tertiary: {
      wrapper:
        "bg-white/80 backdrop-blur-md text-gray-900 border border-white/40",
      icon: "bg-secondary-dark text-white",
    },
  }

  const s = sizes[size]
  const t = variants[variant]

  //shimmer effect on hover
  const shimmer = (
    <span className="pointer-events-none absolute inset-0 rounded-full overflow-hidden">
      <span className="absolute -left-[60%] top-0 rounded-full opacity-60 h-full w-[50%] bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:left-[120%] transition-all duration-700 ease-out"></span>
    </span>
  )

  if (link)
    return (
      <Link
        to={link}
        className={`relative inline-flex items-center rounded-full font-medium transition-all duration-300 group w-fit ${s.wrapper} ${t.wrapper}`}
      >
        {shimmer}
        {text}
        <span
          className={`absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center rounded-full transition-transform duration-300 group-hover:rotate-45 ${s.iconWrapper} ${t.icon}`}
        >
          <GoArrowUpRight size={s.icon} />
        </span>
      </Link>
    )

  return (
    <button
      className={`relative inline-flex items-center rounded-full font-medium transition-all duration-300 group w-fit ${s.wrapper} ${t.wrapper}`}
    >
      {shimmer}
      {text}
      <span
        className={`absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center rounded-full transition-transform duration-300 group-hover:rotate-45 ${s.iconWrapper} ${t.icon}`}
      >
        <GoArrowUpRight size={s.icon} />
      </span>
    </button>
  )
}
